import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const NavigationPath = ({ paths }) => {
    if (!paths || paths.length === 0) return null;

    return (
        <nav aria-label="breadcrumb" style={styles.breadcrumbNav}>
            <ol style={styles.breadcrumbList}>
                {paths.map((path, index) => {
                    const isLast = index === paths.length - 1;
                    return (
                        <React.Fragment key={index}>
                            <li
                                style={{
                                    ...styles.breadcrumbItem,
                                    ...(index === 0 ? styles.firstItem : {}),
                                    ...(isLast ? styles.activeItem : {}),
                                }}
                            >
                                {isLast || !path.path ? (
                                    <span style={{ fontSize: '1.1rem' }}>{path.name}</span>
                                ) : (
                                    <HoverLink style={{ fontSize: '1.1rem' }} to={path.path} label={path.name} />
                                )}
                            </li>
                            {!isLast && <span style={styles.separator}>›</span>}
                        </React.Fragment>
                    );
                })}
            </ol>
        </nav>
    );
};

const HoverLink = ({ to, label }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <Link
            to={to}
            style={{
                ...styles.breadcrumbButton,
                ...(hovered ? styles.breadcrumbButtonHover : {}),
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {label}
        </Link>
    );
};

HoverLink.propTypes = {
    to: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

const styles = {
    breadcrumbNav: {
        padding: '10px 0',
        backgroundColor: 'transparent',
    },
    breadcrumbList: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        fontSize: '0.95rem',
        rowGap: '4px', // space between wrapped rows
    },
    firstItem: {
        paddingLeft: '10px',
    },
    activeItem: {
        fontWeight: 600,
        color: 'black',
        paddingLeft: '10px',

    },
    breadcrumbLink: {
        color: 'black',
        textDecoration: 'none',
        fontWeight: 500,
        fontSize: '1.1rem',
        transition: 'color 0.25s ease, fontSize 0.25s ease',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    breadcrumbLinkHover: {
        color: '#007bff',
        fontSize: '1rem',
        textDecoration: 'underline',
    },
    breadcrumbButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 12px',
        borderRadius: '8px', // less “pill”, more button
        backgroundColor: '#6ad989',
        color: '#ffffff', // white
        fontWeight: 500,
        fontSize: '0.9rem',
        cursor: 'pointer',
    },
    breadcrumbButtonHover: {
        backgroundColor: '#6ad989',
        borderColor: '#d1d5db',
        transform: 'scale(1.05)',
    },
    separator: {
        margin: '0 7px',
        color: '#bbb',
        whiteSpace: 'nowrap',
    },
};

NavigationPath.propTypes = {
    paths: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
                .isRequired,
            path: PropTypes.string,
        })
    ).isRequired,
};

export default NavigationPath;